module.exports = __webpack_public_path__ + "img/floppy-disk-circle-arrow-right.ded0c974.svg";